module.exports = "{{#if avatarUrl}}\r\n    <span style=\"background-image: url({{avatarUrl}});\" class=\"avatar-icon avatar-icon_list\"></span>\r\n{{else}}\r\n    <span class=\"avatar-icon avatar-icon_list\">{{abbreviation}}</span>\r\n{{/if}}\r\n<span class=\"js-fullName\">{{text}}</span>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/reference/templates/userReferenceListItem.hbs
// module id = 680
// module chunks = 0